export const FORM_TYPES = [
  { label: 'Workflow Client Form (Step/Detail)', value: 1 },
  { label: 'Workflow Client Form with Sub Entity (Step)', value: 2 },
];

const WORKFLOW_CLIENT_FORM_TYPE = 1;
export const WORKFLOW_CLIENT_WITH_STEP_ENTITY_FORM_TYPE = 2;

export const initialFormSettings = {
  formType: WORKFLOW_CLIENT_FORM_TYPE,
  organization: 'All Organization',
  formName: '',
  entity: '',
  subEntity: '',
};

export const initialErrors = {
  formName: { hasError: false, errorText: '' },
  subEntity: { hasError: false, errorText: '' },
  entity: { hasError: false, errorText: '' },
};
